import { useParams, Link } from "react-router-dom";
import blogs from "../data/blogData";

function BlogDetail() {
  const { slug } = useParams();

  const blog = blogs.find((b) => b.slug === slug);

  if (!blog) {
    return <h2 style={{ textAlign: "center" }}>Blog Not Found</h2>;
  }

  return (
    <>
      {/* Breadcrumb Section */}
      <section className="page-title custom-breadcrumb">
        <div className="overlay"></div>
        <div className="auto-container">
          <div className="content-box">
            <h1>{blog.title}</h1>

            <ul className="bread-crumb">
              <li><Link to="/">Home</Link></li>
              <li><span>→</span></li>
              <li className="active">{blog.title}</li>
            </ul>

          </div>
        </div>
      </section>

      {/* Blog Content */}
      <div className="container blog-detail">
		<div className="blog-header mt-5">
		<span class="category">{blog.category}</span>
        <h1>{blog.title}</h1>

        <div className="meta">
          <span>📅 {blog.date}</span>
          <span>👤 {blog.author}</span>          
        </div>
		</div>
		
		<div className="blog-image">
			<img src={blog.image} alt={blog.title} style={{ width: "100%", margin: "20px 0" }} />
		</div>

        <div className="blog-content" dangerouslySetInnerHTML={{ __html: blog.content }} />

      </div>
    </>
  );
}

export default BlogDetail;